export const InitialValuesProfilJobAccount = {
	/*job: "",*/
	signature: "",
	tags: "",
}